import { Button, TextField } from "@mui/material";
import React, { useContext, useEffect, useRef } from "react";
import { EditableGroupContext } from "../../EditableGroup/EditableGroup";
import flex from "../../../../styles/flex";
import { useTranslation } from "react-i18next";

const PackageField: React.FunctionComponent<{
    label: string,
    value?: string;
    required?: boolean;
    readOnly?: boolean;
    maxWidth?: number | string;
    testId?: string;
    onChange: (value: string) => void;
}> = (props) => {

    const groupContext = useContext(EditableGroupContext);
    const ref = useRef<HTMLInputElement>();
    const { t } = useTranslation();

    useEffect(() => {
        if (ref.current) {
            ref.current.value = props.value || "";
        }
    }, [groupContext.buildId]);

    return (
        <div style={flex.flexRows}>
            <div style={flex.flexFill}>
                <TextField
                    data-testid={props.testId}
                    inputProps={{
                        autoComplete: 'off',
                        name: "input",
                    }}

                    style={{
                        maxWidth: props.maxWidth == null ? 225 : props.maxWidth,
                        width: "100%",

                    }}

                    disabled={true}
                    required={props.required == true}
                    inputRef={ref}

                    size="small"
                    label={props.label}
                    variant="outlined"
                    value={props.value || ""}
                    onChange={(e) => {
                        props.onChange(e.target.value);
                    }}
                />
            </div>
            <div style={flex.flexAuto}>
                <div style={{ marginLeft: 5 }}>
                    <Button variant="contained" color="secondary" data-testid={props.testId ? `${props.testId}-select-button` : undefined}>{t("general.select")}</Button>
                </div>
            </div>
        </div>
    );
}

export default PackageField;